module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr-ca":{"Forecasted Snowfall":"Prévision de neige"}}')
  delete Component.options._Ctor
}
